import { getEntities } from "api/generated/entities/entities";

export function checkRemoteNameAvailability(
    name: string,
    alreadyExistsError: string
): Promise<void> {
    return getEntities({ all: true, name, scope: "risk" }).then((response) => {
        const matchedTitles = response.data;
        if (matchedTitles.content.length > 0) {
            return Promise.reject(new Error(alreadyExistsError));
        } else {
            return Promise.resolve();
        }
    });
}
